import { setRoomQueryData } from '@/actions/room';
import { useDispatch, useSelector } from 'react-redux';

const RoomSidebar = () => {
  const dispatch = useDispatch();
  const query = useSelector((state: any) => state.roomReducer.query.roomList);
  const handleChange = (e) => {
    dispatch(
      setRoomQueryData({
        name: 'roomList',
        value: { ...query, search: e.target.value },
      })
    );
  };
  return (
    <>
      <div className="d-flex align-items-center flex-column p-3">
        <h4 className="">Rooms</h4>

        <input
          value={query.search}
          className="input-hover-border border-0 font-placeholder col-lg-4 py-3 px-4"
          style={{
            borderRadius: '20px',
            height: '40px',
          }}
          type="text"
          onChange={handleChange}
          name="search"
          placeholder="Search your rooms here . . ."
          autoComplete="off"
        />
      </div>
    </>
  );
};
export default RoomSidebar;
